// extracted by mini-css-extract-plugin
export default {"root":"TextDivider_root__ZSsfK","divider":"TextDivider_divider__qAliZ","withMargin":"TextDivider_withMargin__JhIE0","dashed":"TextDivider_dashed__LbPME"};